import { API_IDS } from '@intigral/constant';
import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';

import { DI } from '@intigral/constant/config/DIContainer';
import { ICmsRepository } from '../../core/repositories/interfaces/iCmsRepository';
import { container } from '../../DataDomain';
import { ICmsConfigurationResponse } from '../../entity/interface/iCmsConfiguration';
import { ICmsLanguageResponse } from '../../entity/interface/iCmsLanguage';
import { ICmsScreenResponse } from '../../entity/interface/iCmsScreen';
import { IApiPathManager } from '../config/ApiPathManager';

class CmsRepository implements ICmsRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getConfiguration(): Promise<ICmsConfigurationResponse> {
        const response = await this.http.get<ICmsConfigurationResponse>(
            this.apiPathManager.getPath(API_IDS.CMS_CONFIGURATION),
            {
                headers: {
                    'app-key': process.env['NX_CMS_APP_KEY'] || '',
                },
            }
        );
        return response.data;
    }

    async getLanguage(language: string): Promise<any> {
        const response = await this.http.get<ICmsLanguageResponse>(this.apiPathManager.getPath(API_IDS.CMS_LANGUAGE), {
            params: {
                language: language,
            },
            headers: {
                'app-key': process.env['NX_CMS_APP_KEY'] || '',
            },
        });
        return response.data;
    }

    async getScreen(screen: string): Promise<ICmsScreenResponse> {
        const response = await this.http.get<ICmsScreenResponse>(this.apiPathManager.getPath(API_IDS.CMS_SCREEN), {
            params: {
                screen,
            },
            headers: {
                'app-key': process.env['NX_CMS_APP_KEY'] || '',
            },
        });
        return response.data;
    }
}

export default CmsRepository;
